const arsFormatter = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 });

export const formatARS = (value: number): string => arsFormatter.format(Number(value) || 0);
